// Slovenské dvojče locale/cs/infoPage.js.
export default {
  galleryAlt: 'Fotografia predajne',
  playVideo: 'Prehrať video',
  openMap: 'Otvoriť v mapách',
};
